import axios from "axios";
import { API_URL } from "../config/constants";


const axiosapi = axios.create(
{  
        baseURL: API_URL,
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
    });


const refreshTokens = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
        throw new Error('No refresh token available');
    }
    try {
        const response = await axiosapi.post('/refresh-token', { refreshToken });
        localStorage.setItem('accessToken', response.data.accessToken);
        return response.data.accessToken;
    } catch (error) {
        console.error('Error refreshing tokens:', error);
        throw error;
    }
};

axiosapi.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            window.location.reload();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosapi.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        originalRequest._retry = false;
        
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const accessToken = await refreshTokens();
                originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                return axiosapi(originalRequest);
            } catch (refreshError) {
                console.error('Error refreshing tokens:', refreshError);
                window.location.reload();
                return Promise.reject(refreshError);
            }
        } 
        else if (error.response.status === 403 ) {
            console.error('Invalid token');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refresh_token');
            window.location.reload();
        }
        
        else { 
         console.error('Error Occurred',error.response);
        }
 
         return Promise.reject(error);
    }
);



export default axiosapi;
